import React, { useState } from "react"
import MetaTags from 'react-meta-tags';
import {
  Container,
  Card, CardBody,
} from "reactstrap"
import { Link } from "react-router-dom"
import { get } from "../../helpers/api_helper"
import * as url from "../../helpers/url_helper"
import { connect } from "react-redux"


const QR = props => {

  const [loading, setLoading] = React.useState(true);
  const [assets, setAssets] = React.useState([]);

  const [query, setQuery] = React.useState('');

  const fetchData = () => {
    setLoading(true);
    // console.log('::ID:', props.location.state.id);
    get(url.GET_QR+'/'+props.filterBlock.id).then(response => {
      console.log('RESP', response);
      if (response.status == 200) {
        setAssets(response.data.assets);
        setLoading(false);
      }
      else {
        setAssets(null);
        setLoading(false);
      }
    })
      .catch(error => {
        console.log('err:', error);
      });
  };


  React.useEffect(()=>{
    if(props.filterBlock) {
      setQuery('');
    fetchData();
    }
  }, [props.filterBlock]);

  const displayed = query == '' ? assets.slice(0, 8) : assets.filter(a => a.name.toLowerCase().includes(query.toLowerCase())).slice(0, 8);

  // const searchRes = this.props.members.filter(item => item.name.toLowerCase().includes(this.state.query.toLowerCase()))


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>QR codes </title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-4">QR Codes</h3>
            {/* <Link className="btn btn-secondary" to="/forms/index">Back</Link> */}
          </div>
          {assets.length < 1 ?
            <div>No assets to show</div> :
            <div>
              <div className="mb-4">
                <input type="text" className="form-control" placeholder="Search.." id="query" value={query} onChange={(e) => { setQuery(e.target.value); }} />
              </div>
              <div className="row">
                {displayed.map((asset, assetIdx) => (
                  <div key={assetIdx} className="col-3">
                    <Card>
                      <CardBody>
                      {/* <QRCode 
                        value={asset.asset_code}
                        size={100}
                        level="M"
                        // style={{borderColor: 'red', borderWidth: 1,}} 
                        /> */}
                        <img 
                          src={"https://chart.googleapis.com/chart?cht=qr&chs=300x300&chl="+asset.asset_code+"&choe=UTF-8&chld=M|2"} 
                          style={{width: '100%'}}
                          />
                      <div className="mt-3">{asset.name}</div>
                      <div>{asset.building?.name} {asset.floor?.name} {asset.room?.name}</div>
                    </CardBody>

                    </Card>
                  </div>
                ))}
              </div>
            </div>
          }

          <div className="mb-4 container">
            <div className="d-flex justify-content-center">
              <Link className="btn btn-light" to="/forms/index">Back</Link>
            </div>
          </div>

        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  const {
    filterBlock,
  } = state.filters
  return { filterBlock }
}

export default connect(mapStatetoProps)(QR)